import { DATE_FULL, DATE_SHORT } from '@/core/dateHelper/dateFormats';
import { useCallback, useMemo } from 'react';
import { toLocaleDateString } from '@/core/dateHelper/dateService';
import { defaultLocalization } from './localizationTypes';
import { useLocalization } from './useLocalization';

export const useLocaleDateFormatter = () => {
  const { locale } = useLocalization();

  const fixedLocale = useMemo(() => {
    try {
      // our supported locale strings are invalid Intl.locale objects for spanish, due to _
      // right locale with - instead of _
      const fixUnderscore = locale?.replace('_', '-');
      return new Intl.Locale(fixUnderscore).baseName;
    } catch (e) {
      return defaultLocalization.locale;
    }
  }, [locale]);

  const dateToLocaleFormat = useCallback(
    (
      date: Date | string | number | null,
      format?: Intl.DateTimeFormatOptions
    ) => toLocaleDateString(date, fixedLocale, format),
    [fixedLocale]
  );

  const dateToLocaleShort = useCallback(
    (date: Date | string | number | null) =>
      dateToLocaleFormat(date, DATE_SHORT),
    [dateToLocaleFormat]
  );

  const dateToLocaleFull = useCallback(
    (date: Date | string | number | null) =>
      dateToLocaleFormat(date, DATE_FULL),
    [dateToLocaleFormat]
  );

  return { dateToLocaleFormat, dateToLocaleShort, dateToLocaleFull };
};
